import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      // Show banner slightly after load for better UX
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem('cookie-consent', 'all');
    setIsVisible(false);
  };

  const acceptEssential = () => {
    localStorage.setItem('cookie-consent', 'essential');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-slate-900 border-t border-slate-700 text-white p-6 z-[100] shadow-2xl">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex-1">
          <h3 className="text-lg font-bold mb-2">Wir respektieren Ihre Privatsphäre</h3>
          <p className="text-sm text-slate-300">
            Wir verwenden Cookies, um Ihnen die bestmögliche Erfahrung auf unserer Website zu bieten. 
            Einige sind essenziell (z.B. für die Sicherheit), während andere uns helfen, diese Website zu verbessern. 
            Weitere Informationen finden Sie in unserer{' '}
            <Link to="/datenschutz" className="text-cyan-400 hover:text-cyan-300 underline">
              Datenschutzerklärung
            </Link>.
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 shrink-0 w-full md:w-auto">
          <button 
            onClick={acceptEssential}
            className="px-6 py-2.5 border border-slate-600 text-slate-300 hover:bg-slate-800 rounded-md text-sm font-medium transition-colors whitespace-nowrap"
          >
            Nur essenzielle
          </button>
          <button 
            onClick={acceptAll}
            className="px-6 py-2.5 bg-cyan-600 hover:bg-cyan-500 text-white rounded-md text-sm font-medium transition-colors whitespace-nowrap"
          >
            Alle akzeptieren
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;